
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    chatTitle: 'Write to support',
    chatHint: 'We answer in the chat here — attach a screenshot if it helps.',
    chatAction: 'Open chat',
    title: 'Support',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Working hours',
    labelResponse: 'Response time',
    valueHours: '12:00–18:00 on business days',
    valueResponse: '24 hours',
  },
  ru: {
    chatTitle: 'Написать в поддержку',
    chatHint: 'Ответим прямо здесь, в чате. Можешь приложить скриншот.',
    chatAction: 'Открыть чат',
    title: 'Поддержка',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Часы работы',
    labelResponse: 'Срок ответа',
    valueHours: '12–18 ежедневно по рабочим дням',
    valueResponse: '24 часа',
  },
  uz: {
    chatTitle: 'Qoʻllab-quvvatlashga yozish',
    chatHint: 'Shu yerda, chatda javob beramiz. Skrinshot ilova qilishing mumkin.',
    chatAction: 'Chatni ochish',
    title: 'Qoʻllab-quvvatlash',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Ish vaqti',
    labelResponse: 'Javob muddati',
    valueHours: 'Ish kunlari 12:00–18:00',
    valueResponse: '24 soat',
  },
  fa: {
    chatTitle: 'به پشتیبانی بنویس',
    chatHint: 'همین‌جا در چت جواب می‌دهیم — اگر کمک می‌کند، اسکرین‌شات بفرست.',
    chatAction: 'باز کردن چت',
    title: 'پشتیبانی',
    labelEmail: 'ایمیل',
    labelTelegram: 'تلگرام',
    labelHours: 'ساعت کاری',
    labelResponse: 'زمان پاسخ',
    valueHours: '12:00–18:00 روزهای کاری',
    valueResponse: '24 ساعت',
  },
  pt: {
    chatTitle: 'Escrever para o suporte',
    chatHint: 'Respondemos aqui mesmo, no chat. Pode anexar um print.',
    chatAction: 'Abrir chat',
    title: 'Suporte',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Horário de atendimento',
    labelResponse: 'Tempo de resposta',
    valueHours: '12:00–18:00 em dias úteis',
    valueResponse: '24 horas',
  },
  tr: {
    chatTitle: 'Desteğe yaz',
    chatHint: 'Burada, sohbette cevaplıyoruz. Ekran görüntüsü de ekleyebilirsin.',
    chatAction: 'Sohbeti aç',
    title: 'Destek',
    labelEmail: 'E-posta',
    labelTelegram: 'Telegram',
    labelHours: 'Çalışma saatleri',
    labelResponse: 'Yanıt süresi',
    valueHours: 'İş günlerinde 12:00–18:00',
    valueResponse: '24 saat',
  },
  uk: {
    chatTitle: 'Написати в підтримку',
    chatHint: 'Відповімо прямо тут, у чаті. Можеш додати скриншот.',
    chatAction: 'Відкрити чат',
    title: 'Підтримка',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Години роботи',
    labelResponse: 'Термін відповіді',
    valueHours: '12:00–18:00 у робочі дні',
    valueResponse: '24 години',
  },
  de: {
    chatTitle: 'An den Support schreiben',
    chatHint: 'Wir antworten direkt hier im Chat – häng gern einen Screenshot an.',
    chatAction: 'Chat öffnen',
    title: 'Support',
    labelEmail: 'E-Mail',
    labelTelegram: 'Telegram',
    labelHours: 'Arbeitszeiten',
    labelResponse: 'Antwortzeit',
    valueHours: '12:00–18:00 Uhr an Werktagen',
    valueResponse: '24 Stunden',
  },
  es: {
    chatTitle: 'Escribir a soporte',
    chatHint: 'Te respondemos aquí mismo, en el chat. Puedes adjuntar una captura de pantalla.',
    chatAction: 'Abrir chat',
    title: 'Soporte',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Horario de atención',
    labelResponse: 'Tiempo de respuesta',
    valueHours: '12:00–18:00 en días laborables',
    valueResponse: '24 horas',
  },
  pl: {
    chatTitle: 'Napisz do wsparcia',
    chatHint: 'Odpowiemy tutaj, w czacie. Możesz dodać zrzut ekranu.',
    chatAction: 'Otwórz czat',
    title: 'Wsparcie',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Godziny pracy',
    labelResponse: 'Czas odpowiedzi',
    valueHours: '12:00–18:00 w dni robocze',
    valueResponse: '24 godziny',
  },
});
